import React, { Component } from "react"

class OptionsAndPrice extends Component {
  render() {
    const { prices, menuType } = this.props

    let opts = ""
    switch (menuType) {
      case "Entrée plat ou plat dessert":
        opts =
          "Formule entrée & plat ou plat & dessert à " +
          new Intl.NumberFormat("fr-Fr", {
            style: "currency",
            currency: "EUR",
          }).format(prices.tarifEntreePlatOuPlatDessert)
        break
      case "Entrée plat dessert":
        opts =
          "Formule entrée & plat & dessert à " +
          new Intl.NumberFormat("fr-Fr", {
            style: "currency",
            currency: "EUR",
          }).format(prices.tarifEntreePlatDessert)

        break
      case "Entrée plat ou plat dessert ou la totale":
        opts =
          "Formule entrée & plat ou plat & dessert à " +
          new Intl.NumberFormat("fr-Fr", {
            style: "currency",
            currency: "EUR",
          }).format(prices.tarifEntreePlatOuPlatDessert) +
          " ou\n" +
          "Formule entrée & plat & dessert à " +
          new Intl.NumberFormat("fr-Fr", {
            style: "currency",
            currency: "EUR",
          }).format(prices.tarifEntreePlatDessert)
        break
      default:
        opts =
          "Formule entrée & plat à " +
          new Intl.NumberFormat("fr-Fr", {
            style: "currency",
            currency: "EUR",
          }).format(prices.tarifEntreePlatOuPlatDessert)
    }

    return <h2 className="h5 text-center">{opts}</h2>
  }
}

export default OptionsAndPrice
